import { ProfileCardDescription, useDialogHistoryManager } from "./styles/components/ProfileCardDescription/ProfileCardDescription.mjs";
import { DefinitionList } from "./styles/components/DefinitionList/DefinitionList.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
import { VerificationLogo, SeekPassIconVerified } from "@seek/certsy-ui";
import { useTranslations } from "@vocab/react";
import { Dialog, Stack, Text, Actions, ButtonLink, IconNewWindow, Button, Box, TooltipRenderer, Bleed } from "braid-design-system";
import { useCallback } from "react";
import { translations } from "./components/CertsyDialog/.vocab/index.mjs";
import { translations as translations$1 } from "./components/CertsyVerifiedIndicator/.vocab/index.mjs";
const CertsyDialog = ({
  onClose,
  certsyUrl,
  onCertsyClick,
  bodyText,
  certsyButtonText,
  open,
  title,
  width = "small",
  data,
  seekPassLogo = /* @__PURE__ */ jsx(VerificationLogo, {})
}) => {
  const { t } = useTranslations(translations);
  const onClick = useCallback(() => {
    if (onCertsyClick) {
      onCertsyClick();
    }
    onClose();
  }, [onCertsyClick, onClose]);
  const certsyLogo = /* @__PURE__ */ jsx(Box, { children: seekPassLogo });
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      id: "certsyDialog",
      illustration: certsyLogo,
      width,
      onClose,
      closeLabel: t("Close"),
      open,
      title,
      data,
      children: /* @__PURE__ */ jsxs(Stack, { space: "large", align: "center", children: [
        typeof bodyText === "string" ? /* @__PURE__ */ jsx(Text, { align: "center", children: bodyText }) : bodyText,
        /* @__PURE__ */ jsxs(Actions, { children: [
          /* @__PURE__ */ jsxs(
            ButtonLink,
            {
              href: certsyUrl,
              onClick,
              target: "_blank",
              rel: "noopener",
              role: "button",
              tone: "formAccent",
              children: [
                certsyButtonText,
                " ",
                /* @__PURE__ */ jsx(
                  IconNewWindow,
                  {
                    alignY: "lowercase",
                    title: t("Opens in a new tab"),
                    titleId: "certsyLinkIcon"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx(Button, { variant: "transparent", tone: "formAccent", onClick: onClose, children: t("Maybe later") })
        ] })
      ] })
    }
  );
};
const focusOutlineGutter = "xxsmall";
const CertsyVerifiedIndicator = ({
  idSuffix,
  showVerifiedText = false
}) => {
  const { t } = useTranslations(translations$1);
  return /* @__PURE__ */ jsx(
    TooltipRenderer,
    {
      id: `certsy-verified-indicator-tooltip-${idSuffix}`,
      tooltip: /* @__PURE__ */ jsx(Text, { children: t("Verified by SEEK Pass") }),
      children: ({ triggerProps }) => /* @__PURE__ */ jsx(Bleed, { space: focusOutlineGutter, children: /* @__PURE__ */ jsx(
        Box,
        {
          "aria-label": t("Verified by SEEK Pass"),
          ...triggerProps,
          padding: focusOutlineGutter,
          data: {
            automation: `certsy-verified-indicator-${idSuffix}`,
            testid: `certsy-verified-indicator-${idSuffix}`
          },
          children: /* @__PURE__ */ jsxs(Text, { children: [
            /* @__PURE__ */ jsx(SeekPassIconVerified, {}),
            " ",
            showVerifiedText ? t("Verified") : null
          ] })
        }
      ) })
    }
  );
};
export {
  CertsyDialog,
  CertsyVerifiedIndicator,
  DefinitionList,
  ProfileCardDescription,
  useDialogHistoryManager
};
